import {Alert, Button} from 'antd';
import {ExportOutlined} from '@ant-design/icons';

/**
 * Where Daba Academy's numbers live now.
 *
 * Until mid-August 2026, Academy was sold through the users service and every
 * purchase was written to `externalpaymentlogs`, which is what this page's
 * stats count. The Academy LMS (dabaacademy.com) has handled checkout since,
 * and records sales, enrollments and revenue in its own database. So the
 * figures on this page stop in August: they are the pre-LMS history, not a
 * broken query. Current numbers are in the Academy admin.
 *
 * "Open Academy admin" signs the admin in there directly. It POSTs the
 * platform token in a form body to the Academy's admin SSO endpoint, which
 * verifies it, requires platform-admin access, and lands on the Academy
 * dashboard. A form POST rather than a link keeps the token out of URLs,
 * history and Referer headers, and needs no CORS.
 */

const ACADEMY_URL = (
  process.env.REACT_APP_ACADEMY_URL || 'https://dabaacademy.com'
).replace(/\/$/, '');

const openAcademyAdmin = () => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${ACADEMY_URL}/api/auth/admin-sso`;
  form.target = '_blank';

  const fields = {
    token: localStorage.getItem('token') || '',
    redirect: '/admin/dashboard',
  };
  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  form.remove();
};

export const AcademyAdminNotice = () => (
  <Alert
    type="warning"
    showIcon
    style={{marginBottom: 16, borderRadius: 8}}
    message="Daba Academy stats have moved to the Academy admin"
    description={
      <div>
        <p style={{margin: '4px 0 12px'}}>
          Since mid-August 2026, Academy courses are sold through the Academy
          platform, which tracks its own sales, enrollments and revenue. The
          figures below only cover purchases made through the old checkout
          before that switch, which is why they stop in August.
        </p>
        <Button
          type="primary"
          icon={<ExportOutlined />}
          onClick={openAcademyAdmin}>
          Open Academy admin
        </Button>
      </div>
    }
  />
);
